import cn from 'client/utils/cn';

import React, { Component, CSSProperties } from 'react';

import { NumberOfServiceUsers } from 'client/bundles/types';
import Help from 'client/components/help';

import './index.css';

const b = cn('service-card');

interface Props {
    services: NumberOfServiceUsers[];
}

class ActiveUsersOfServices extends Component<Props> {
    renderItem = ({ logo, number, description, help }: NumberOfServiceUsers) => (
        <div className={b('service')} key={logo}>
            <i className={b('logo')} style={{ '--service-logo': `url(${logo})` } as CSSProperties} />
            <div className={b('text')}>
                <div className={b('title')}>
                    <b className={b('number')}>{number}</b>
                    {help && (
                        <Help content={help} mixPopup={b('help-popup')} />
                    )}
                </div>
                <div className={b('description')} dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    )

    render() {
        const { services } = this.props;

        return (
            <ul className={b()}>
                {services.map(item => this.renderItem(item))}
            </ul>
        );
    }
}

export default ActiveUsersOfServices;
